import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import ProfileCreateView from "../views/ProfileCreateView";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import ProfileCreateViewStore from "../../stores/ProfileCreateViewStore";
import SavingStates from "../../constants/states/SavingStates";

class ProfileCreateContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "profileCreateViewStoreState": ProfileCreateViewStore.getState()
        };
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.profileCreateViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PROFILE_CREATE_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
        EventPublisher.unsubscribe(this.profileCreateViewStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "profileCreateViewStoreState": ProfileCreateViewStore.getState()
        });
    };

    render() {
        return (
            <ProfileCreateView
                isSaving={this.state.profileCreateViewStoreState.savingState === SavingStates.SAVING}
                googleAPILibReady={this.state.googleAPILibState.loadingState === LoadingStates.FINISHED_LOADING}
                displayName={this.state.profileCreateViewStoreState.displayName}
                email={this.state.profileCreateViewStoreState.email}
                phoneNumber={this.state.profileCreateViewStoreState.phoneNumber}
                about={this.state.profileCreateViewStoreState.about}
                paymentAddressName={this.state.profileCreateViewStoreState.paymentAddressName}
                currentPaymentAddressGooglePlaceId={this.state.profileCreateViewStoreState.currentPaymentAddressGooglePlaceId}
                currentPaymentAddressStreetNumber={this.state.profileCreateViewStoreState.currentPaymentAddressStreetNumber}
                currentPaymentAddressRoute={this.state.profileCreateViewStoreState.currentPaymentAddressRoute}
                currentPaymentAddressSecondaryAddress={this.state.profileCreateViewStoreState.currentPaymentAddressSecondaryAddress}
                currentPaymentAddressLocality={this.state.profileCreateViewStoreState.currentPaymentAddressLocality}
                currentPaymentAddressAdministrativeAreaLevel1={this.state.profileCreateViewStoreState.currentPaymentAddressAdministrativeAreaLevel1}
                currentPaymentAddressAdministrativeAreaLevel2={this.state.profileCreateViewStoreState.currentPaymentAddressAdministrativeAreaLevel2}
                currentPaymentAddressCountryLong={this.state.profileCreateViewStoreState.currentPaymentAddressCountryLong}
                currentPaymentAddressCountryShort={this.state.profileCreateViewStoreState.currentPaymentAddressCountryShort}
                currentPaymentAddressPostalCode={this.state.profileCreateViewStoreState.currentPaymentAddressPostalCode}
            />
        );
    }

}

export default ProfileCreateContainer;